import { get } from 'lodash';
import { TYPE_FASTER_PAYMENTS, TYPE_BACS_CREDIT, TYPE_BACS_DEBIT, TYPE_CHAPS } from '../../../src/config';

export const getTemplateListByType = (state, type) => {
	const list = get(state, 'templates.list', []);
	return list.filter((template) => template.type === type).map(({ name, id }) => ({ name, id }));
};

export const getTemplateName = (state) => get(state, 'templates.currentTemplate.name', '');

export const getIsDuplicate = (state) => get(state, 'templates.currentTemplate.duplicateName', false);

export const getCurrentTemplateId = (state) => get(state, 'templates.currentTemplate.id');

export const getCurrentTemplateVersion = (state) => get(state, 'templates.currentTemplate.version');

export const getIsVersionConflict = (state) => get(state, 'templates.currentTemplate.versionConflict', false);

export const getLastSaveType = (state) => get(state, 'templates.lastSaveType', '');

export const getTemplateLastUpdatedBy = (state) => get(state, 'templates.currentTemplate.lastUpdatedBy', '');

export const getTemplateLastUpdatedTime = (state) => get(state, 'templates.currentTemplate.lastUpdatedTime', '');

export const getIsTemplateListEmpty = (state, type) => getTemplateListByType(state, type).length === 0;

// TODO move to a more appropriate place after reducer move

export const getMissingBenInTemplate = (state) => {
	const {
		accounts,
		payees,
		modes: { paymentType },
		bacsDebit,
		bacsCredit,
		payments,
		chaps,
	} = state;

	if (!getCurrentTemplateId(state)) {
		return false;
	}

	const getIsValidAccountOrPayee = (accountToCheck) =>
		accounts.find((acc) => acc.id === accountToCheck) || payees.find((payee) => payee.id === accountToCheck);

	switch (paymentType) {
		case TYPE_BACS_DEBIT:
			return (
				!getIsValidAccountOrPayee(bacsDebit.toAccount) ||
				!!bacsDebit.payments.find((payment) => !getIsValidAccountOrPayee(payment.fromAccount))
			);
		case TYPE_BACS_CREDIT:
			return (
				!getIsValidAccountOrPayee(bacsCredit.fromAccount) ||
				!!bacsCredit.payments.find((payment) => !getIsValidAccountOrPayee(payment.toAccount))
			);
		case TYPE_FASTER_PAYMENTS:
			return (
				!!payments.find((payment) => !getIsValidAccountOrPayee(payment.toAccount)) ||
				!!payments.find((payment) => !getIsValidAccountOrPayee(payment.fromAccount))
			);
		case TYPE_CHAPS:
			return (
				!!chaps.payments.find((payment) => !getIsValidAccountOrPayee(payment.toAccount)) ||
				!!chaps.payments.find((payment) => !getIsValidAccountOrPayee(payment.fromAccount))
			);

		default:
			return false;
	}
};

export const getIsTemplateMode = (state) => get(state, 'templates.templateMode', false);
